export default __webpack_public_path__ + "static/media/MYSQL.2a49a619.svg";